module.exports = {
  fetch: `query getLabAssets {
    labAssets {
      id
      name {
        en
        es
      }
      type
      key
      productTypes
    }
  }`,
};
